<template>
  <div class="experience-map-modal">
    <div class="modal-overlay" @click="$emit('close')"></div>
    <div class="modal-content-exp">
      <div class="modal-header-exp">
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>
      <div class="modal-body-exp">
        <div v-if="this.markers.length == 0 && visible && !loading" class="text-center py-3 raleway-semi-15">Hortense est à la recherche d'expériences à vous proposer près de cet hébergement</div>
        <div class="container-label w-100">
          <ExperienceMap v-if="visible" :currentLodging="this.lodging" :markers="this.markers" :selectedExperience="this.selectedExperience"
                  :lodgings="this.previous_lodging" @markerSelected="selectCardMap" :selectCardMap="selectCardMap"
                  :selectCard="selectCard" @close="showMap = false"
                  ></ExperienceMap>
        </div>
        <div class="container-label w-100" id="map-bottom">
          <div class="col-md-12" id="map-wrapper">
            <div class="">
            </div>
            <div class="category-icon-wrapper">
              <ul class="icon-list">
                <li @click="filterExperiences('culturelles')"
                  :class="activeCategories.includes('culturelles') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/museum.svg" alt="home1" />
                </li>
                <li @click="filterExperiences('culinaires')"
                  :class="activeCategories.includes('culinaires') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/restaurant1.svg" alt="restaurant1" />
                </li>
                <li @click="filterExperiences('au bord de l\'eau')"
                  :class="activeCategories.includes('au bord de l\'eau') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/restaurant1_group3.svg" alt="group3" />
                </li>
                <li @click="filterExperiences('au naturel')"
                  :class="activeCategories.includes('au naturel') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/leaves.svg" alt="leaves" />
                </li>
                <li @click="filterExperiences('sportives')"
                  :class="activeCategories.includes('sportives') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/sports1.svg" alt="sports1" />
                </li>
                <li @click="filterExperiences('immersives')"
                  :class="activeCategories.includes('immersives') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/gamer1.svg" alt="gamer1" />
                </li>
                <li @click="filterExperiences('DIY')"
                  :class="activeCategories.includes('DIY') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/diy.svg" alt="diy" />
                </li>
                <li @click="filterExperiences('oenologiques')"
                  :class="activeCategories.includes('oenologiques') ? 'li-active' : 'li-inactive'">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/glass-with-wine.svg" alt="glass-with-wine" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetcher from "../packs/shared/api.js";
import ExperienceMap from './ExperienceMap.vue';

export default {
  name: "ExperienceMapModal",
  props: {
    lodging: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    focusedExperience: {
      type: Object,
      default: null
    }
  },
  components: {
    ExperienceMap
  },
  data() {
    return {
      selectedExperience: '',
      activeCategories: [],
      allExperiences: {},
      experiencesByCategory: {},
      categories: [
        { display: 'Les expériences culturelles', backend: 'Culturelles' },
        { display: 'Les expériences au naturel', backend: 'Au Naturel' },
        { display: 'Les expériences au bord de l\'eau', backend: 'Au bord de leau' },
        { display: 'Les expériences sportives', backend: 'Sportives' },
        { display: 'Les expériences immersives', backend: 'Immersives' },
        { display: 'Les expériences culinaires', backend: 'Culinaries' },
        { display: 'Les expériences DIY', backend: 'Diy' },
        { display: 'Les expériences oenologiques', backend: 'Oenologiques' }
      ],
      showMap: false,
      categoryMarkers: {},
      markers: [],
      previous_lodging: [],
      categoryDescriptions: {},
      dataFetched: false,
      loading: false,
      isPhone: window.innerWidth < 768
    };
  },
  mounted() {
    if (this.focusedExperience) {
      // If we have a focused experience, show only that one
      this.setupFocusedExperience();
    } else if (!this.dataFetched) {
      // Otherwise, fetch all experiences as usual
      this.fetchAllExperiences();
      this.dataFetched = true;
    }
    this.showMap = true;
    const bmBurgerButton = document.querySelector('.bm-burger-button');
    if (bmBurgerButton) {
      bmBurgerButton.style.display = 'none';
    }
  },
  beforeDestroy() {
    // Always restore body scrolling when component is destroyed
    const bmBurgerButton = document.querySelector('.bm-burger-button');
    if (bmBurgerButton) {
      bmBurgerButton.style.display = 'block';
    }
    this.restoreBodyScroll();
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.preventBodyScroll();
        } else {
          this.restoreBodyScroll();
        }
      },
      immediate: true
    }
  },
  methods: {
    preventBodyScroll() {
      if (!this.isPhone) {
        return;
      }
      // Prevent body scrolling when modal is open
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    },
    restoreBodyScroll() {
      if (!this.isPhone) {
        return;
      }
      // Restore body scrolling when modal is closed
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    },
    filterExperiences(selectedCategory) {
      this.selectedExperience = selectedCategory;
      if (this.activeCategories.includes(selectedCategory)) {
        this.activeCategories = [];
        this.fetchAllExperiences();
      } else {
        this.activeCategories = [selectedCategory];
        this.fetchExperiencesByCategory(selectedCategory);
      }
    },
    selectCard(attr) {
      // Handle card selection
    },
    selectCardMap(markerId) {
      // Handle map marker selection
    },
    async fetchExperiencesByCategory(category) {
      try {
        const response = await fetcher.get(`/categories/${encodeURI(category)}/experiences/list?lodging_id=${this.lodging.id}`);
        this.$set(this.experiencesByCategory, category, response.data);

        if (response.data.length > 0) {
          this.$set(this.categoryDescriptions, response.data[0].name, response.data[0].description);
        }
        this.previous_lodging = response.data;

        const newMarkers = this.markerMap();
        this.$set(this, 'markers', newMarkers);
      } catch (e) {
        console.error(e);
      }
    },
    async fetchAllExperiences() {
      this.loading = true;
      try {
        // Create all API requests concurrently
        const categoryPromises = this.categories.map(category =>
          fetcher.get(`/categories/${encodeURI(category.backend)}/experiences/list?lodging_id=${this.lodging.id}`)
            .then(response => ({
              category: category.display,
              backend: category.backend,
              data: response.data
            }))
            .catch(error => {
              console.error(`Error fetching ${category.display}:`, error);
              return {
                category: category.display,
                backend: category.backend,
                data: []
              };
            })
        );

        // Wait for all requests to complete
        const results = await Promise.all(categoryPromises);
        
        const allLodging = [];
        const result = {};

        // Process all results
        results.forEach(({ category, data }) => {
          this.$set(this.experiencesByCategory, category, data);

          if (data.length > 0) {
            const categoryInfo = data[0];
            this.$set(this.categoryDescriptions, categoryInfo.name, categoryInfo.description);
            allLodging.push(data);

            // Build category markers
            data.forEach(item => {
              const categoryName = item.category_name;
              if (!result[categoryName]) {
                result[categoryName] = [];
              }
              result[categoryName].push([item.longitude, item.latitude, item.id, item.category_name]);
            });
          }
        });

        this.categoryMarkers = result;
        this.previous_lodging = allLodging.flat();
        this.markers = this.markerMap();
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error('Error in fetchAllExperiences:', e);
      }
    },
    markerMap() {
      const markers = [];
      this.previous_lodging.map((el) => {
        markers.push([el.longitude, el.latitude, el.id, el.category_name]);
      });
      return markers;
    },
    setupFocusedExperience() {
      // Set up the modal to show only the focused experience
      this.previous_lodging = [this.focusedExperience];
      this.markers = [[
        this.focusedExperience.longitude,
        this.focusedExperience.latitude,
        this.focusedExperience.id,
        this.focusedExperience.category_name
      ]];
      this.selectedExperience = this.focusedExperience.category_name;
      this.dataFetched = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.experience-map-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none; /* Prevent touch scrolling */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  touch-action: none; /* Prevent touch events from propagating */
}

.modal-content-exp{
  position: relative;
  background: white;
  max-width: 90%;
  max-height: 90%;
  overflow-y: hidden;
  z-index: 1002;
  touch-action: pan-y; /* Allow vertical scrolling within modal */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */

  @media screen and (max-width: 768px) {
    max-width: 100%;
    max-height: 100%;
  }
}

.modal-header-exp {
  @media screen and (min-width: 769px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: right;
    border-bottom: unset;
  }

  @media screen and (max-width: 768px) {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1002;
    margin-right: 2rem;
  }
}

.close-btn {
  font-size: 2rem;
  color: #999;
  @media screen and (min-width: 769px) {
    background: none;
    border: none;
    cursor: pointer;
    
    &:hover {
      color: #333;
    }
  }

  @media screen and (max-width: 768px) {
    width: 36px;
    height: 36px;
    background: #ddd;
    border-radius: 8px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
  }
}

.modal-body-exp {
  padding: 0px 0px 2rem 0px;
}

.desti-header {
  max-width: 65%;
  margin: 0 auto;
}

ul.icon-list {
  display: flex;
  justify-content: space-around;
  background: #efefef;
  padding-left: 0;

  li {
    list-style: none;
    background: #fff;
    margin: 1rem;
    padding: 0.5rem 2.4rem;

    &.li-active {
      background: #3b6152;
    }

    img {
      width: 100%;
      max-width: 57px;
      cursor: pointer;
    }
  }
}

.li-active img {
  filter: brightness(0) invert(1);
}

.li-inactive img {
  filter: invert(0);
}

#map {
  margin: auto !important;
  margin-top: -21px !important;
}

#map-wrapper {
  padding: 0px !important;
}

@media (max-width: 768px) {
  .modal-content-exp{
    width: 100vh;
    height: 100vh;
  }
  
  .modal-body-exp {
    padding: 0;
  }
  
  .desti-header {
    max-width: 100%;
  }
  
  ul.icon-list {
    flex-wrap: nowrap;
    justify-content: space-between;
    overflow-x: auto;
    padding: 0.5rem 0.2rem;

    li {
      padding: 0.2rem 0.3rem;
      margin: 0.1rem;
      flex-shrink: 0;
      min-width: auto;

      img {
        width: 100%;
        max-width: 35px;
        height: auto;
      }
    }
  }
}

</style>